// Gets and sets pid to/from attribution cookie
import './apps/bankrate-cookie'

// This supports the accordion functionality for wordpress conent below table
import './accordions'

// This toggles the "See a summary of our rates" section
import './content-toggle'

// Gets tooltip JS for the auto-rates-tooltip
import './tooltips'
